<template>
  <div>
    <h2>Service Details</h2>

    <el-form
      ref="form"
      :model="detail"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item
            label="Name"
            prop="name"
          >
            <el-input
              v-model="detail.name"
              placeholder="Name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Hide from Pickups"
            prop="hide_from_pickups"
          >
            <br>
            <el-switch
              v-model="detail.hide_from_pickups"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="TIG Service Code (Unique)"
            prop="chainit"
          >
            <el-input
              v-model="detail.chainit"
              placeholder="Shipping Code"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Send EDI"
            prop="type"
          >
            <br>
            <el-select
              v-model="detail.type"
              placeholder="Select a service type"
              class="w-100"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="Carrier Service Code"
            prop="code"
          >
            <el-input
              v-model="detail.code"
              placeholder="Code"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Service Code for EDI"
          >
            <el-input
              v-model="detail.edi"
              placeholder="EDI"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            prop="con"
            label="Service Code for Printed Consignment"
          >
            <el-input
              v-model="detail.con"
              placeholder="Con"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="service_label"
            label="Service Code for Label"
          >
            <el-input
              v-model="detail.service_label"
              placeholder="Label"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="Service Type"
            prop="service_type"
          >
            <el-select
              v-model="detail.service_type"
              clearable
              filterable
              remote
              :remote-method="serviceTypeQuerySearch"
              :loading="isLoading"
              :trigger-on-focus="false"
              class="w-100"
              placeholder="Enter name of service type"
              value-key="id"
              @change="handleSelectServiceType"
            >
              <el-option
                v-for="item in serviceTypes"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Filter, { CONTAINS } from '@/plugins/sdk/Filter'

export default {
  props: {
    detail: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data () {
    return {
      rules: {
        name: [
          { required: true, message: 'Name is required.', trigger: ['blur'] }
        ],
        chainit: [
          { required: true, message: 'Shipping Code is required.', trigger: ['blur'] }
        ],
        code: [
          { required: true, message: 'Code is required.', trigger: ['blur'] }
        ],
        con: [
          { required: true, message: 'Shipping Code is required.', trigger: ['blur'] }
        ],
        service_label: [
          { required: true, message: 'Label is required.', trigger: ['blur'] }
        ],
        type: [
          { required: true, message: 'Type Code is required.', trigger: ['blur'] }
        ]
      },
      typeOptions: [
        {
          label: 'Yes',
          value: '1'
        }, {
          label: 'No',
          value: '0'
        }
      ],
      serviceTypes: [],
      isLoading: false
    }
  },
  methods: {
    serviceTypeQuerySearch (query) {
      if (query) {
        this.isLoading = true
        this.$sdk.commercial_servicetype.list(builder => {
          builder.filters = [
            new Filter('name', CONTAINS, query)
          ]
          builder.limit = 10
        }).then(res => {
          this.serviceTypes = res
          this.isLoading = false
        })
      } else {
        this.serviceTypes = []
      }
    },
    handleSelectServiceType (value) {
      if (value) {
        this.detail.carrier_service_type_id = value.id
      } else {
        this.detail.carrier_service_type_id = null
      }
    }
  }
}
</script>

<style>

</style>
